import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { memo, useCallback } from "react";
export const segmentedControlButton = tailwindVariants({
    base: "rounded px-4 py-1 text-sm font-medium text-grey-12",
    variants: {
        color: {
            blue: "",
            grey: ""
        },
        state: {
            selected: "",
            unselected: "bg-transparent"
        }
    },
    compoundVariants: [
        {
            color: "blue",
            state: "selected",
            class: "bg-blue-9 hover:bg-blue-9"
        },
        {
            color: "grey",
            state: "selected",
            class: "bg-grey-1 hover:bg-grey-1"
        },
        {
            state: "unselected",
            class: "bg-transparent hover:bg-transparent"
        }
    ],
    defaultVariants: {
        color: "grey",
        state: "unselected"
    }
});
export const SegmentedControl = /*#__PURE__*/ memo((param)=>{
    let { options, selectedOption, onSelect, color = "grey" } = param;
    const isSelected = useCallback((option)=>selectedOption.value === option.value, [
        selectedOption
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "inline-flex items-center rounded bg-grey-4 p-1",
        children: options.map((option)=>/*#__PURE__*/ _jsx("button", {
                onClick: ()=>onSelect(option),
                "aria-pressed": isSelected(option),
                type: "button",
                className: segmentedControlButton({
                    color,
                    state: isSelected(option) ? "selected" : "unselected"
                }),
                children: option.label
            }, option.value))
    });
});
SegmentedControl.displayName = "SegmentedControl";
